import React, { useEffect, useState } from "react";
import { URLS } from "../../Services/Constant";
import { get, post } from "../../Services/ApiHandler";

import Loader from "../../Component/Loader";
import { Toast } from "../../Component/Toast";
import useStoreKv from "../redux/store/useStorekv";
import CustomScroll from "../../Component/CustomScroll";

const WinnerAgency = () => {

  const { kv, set } = useStoreKv();
  const gameObj = kv.game_obj || [];

  const [loading, setLoading] = useState(false);
  const [loading1, setLoading1] = useState(null);
  const [loading2, setLoading2] = useState(null);
  const [gameData, setGameData] = useState(gameObj);
  const [popup, setPopup] = useState(false);
  const [popupLoading, setPopupLoading] = useState(false);
  const [pendingUpdate, setPendingUpdate] = useState(null);

  const getList = async () => {
    try {
      // setLoading(true);
      const res = await get(`${URLS.PRICELIST}`);
      console.log("Fetched data:", res);

      if (res?.status === "success" && Array.isArray(res?.data)) {
        setGameData(res?.data);
        set("game_obj", res?.data);
      } else {
        setGameData([]);
        set("game_obj", []);
      }
    } catch (err) {
      Toast("Failed to load data");
      console.error(err);
    } finally {
      // setLoading(false);
    }
  };

  useEffect(() => {
    getList();
  }, []);


  // const handleChange = (fee_price_id, column, value) => {
  //   setGameData((prev) =>
  //     prev.map((ticket) =>
  //       ticket.variations?.some(v => v.fee_price_id === fee_price_id)
  //         ? {
  //           ...ticket,
  //           variations: ticket.variations.map((v) =>
  //             v.fee_price_id === fee_price_id
  //               ? {
  //                 ...v,
  //                 combinations: v.combinations.map((c) =>
  //                   c.column === column ? { ...c, price: value } : c
  //                 ),
  //               }
  //               : v
  //           ),
  //         }
  //         : ticket
  //     )
  //   );
  // };


  const handleUpdateSingle = async (variation) => {

    try {
      setLoading1(variation?.type);

      // Build updates payload
      const updates = variation.combinations.map((c) => ({
        column: c.column,
        price: Number(c.price),
      }));

      const payload = {
        fee_price_id: variation.fee_price_id,
        type: variation.type,
        updates,
      };

      console.log("Update Payload:", payload);

      const res = await post(`${URLS.PRICEUPADTE}`, payload);

      if (res?.status === "success") {
        Toast("Updated successfully");
        getList(); // refresh data
      } else {
        Toast(res?.message || "Failed to update");
      }
    } catch (err) {
      Toast("Failed to update");
      console.error(err);
    } finally {
      setLoading1(false);
      setPopup(false);
      setPopupLoading(false);
      setPendingUpdate(null);
    }
  };

  const confirmUpdate = (updateFunction, ...args) => {
    setPendingUpdate({ func: updateFunction, args });
    setPopup(true);
  };

  const executePendingUpdate = async () => {
    if (pendingUpdate) {
      setPopupLoading(true);
      await pendingUpdate.func(...pendingUpdate.args);
    }
  };


  const handleChange = (fee_price_id, column, value) => {
    setGameData((prev) =>
      prev.map((game) =>
        game.variations?.some((v) => v.fee_price_id === fee_price_id)
          ? {
            ...game,
            variations: game.variations.map((v) =>
              v.fee_price_id === fee_price_id
                ? {
                  ...v,
                  combinations: v.combinations.map((c) =>
                    c.column === column ? { ...c, price: value } : c
                  ),
                }
                : v
            ),
          }
          : game
      )
    );
  };


  const handleUpdate = async (variation) => {
    console.log("variation update", variation?.type)
    try {
      setLoading2(variation?.type);

      // Collect all variations that need update
      const updatesPayload = [];
      gameData.forEach((game) => {
        game.variations?.forEach((variation) => {
          const updates = variation.combinations.map((c) => ({
            column: c.column,
            price: Number(c.price),
          }));
          updatesPayload.push({
            fee_price_id: variation.fee_price_id,
            type: variation.type,
            updates,
          });
        });
      });

      console.log("Update Payload:", updatesPayload);

      // You can either call API for each variation or send all in one request
      for (let payload of updatesPayload) {
        const res = await post(`${URLS.PRICEUPADTE}`, payload);
        if (res?.status !== "success") {
          Toast(res?.message || "Failed to update some entries");
        }
      }

      Toast("All tables updated successfully");
      getList(); // Refresh data
    } catch (err) {
      Toast("Failed to update tables");
      console.error(err);
    } finally {
      setLoading2(false);
      setPopup(false);
      setPopupLoading(false);
      setPendingUpdate(null);
    }
  };

  const threegame = gameData[2];
  const fourgame = gameData[3];

  return (
    <div className="dashRightView d-flex ac-jb flex-column">
      <CustomScroll >
        <div style={{ paddingBottom: 80, paddingTop: 0, paddingRight: 20 }} className="container_overalls">
          <p className=" f2  fs-xs-14 fs-sm-13 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19 my-3">
            This 4 & 3 digit game is based on the daily result of Kerala & Dear
            lottery first prize reults with the last 4 & 3 digits based.
          </p>
          <label style={{ marginTop: 25 }} className="f3 fs-xs-17 fs-sm-11 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19 primary">
            Kerala [Upto 4 digits game]
          </label>
          <p className=" f2  fs-xs-14 fs-sm-13 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19 my-1 Blue_color">
            3:00 PM
          </p>
          <p className=" f2  fs-xs-14 fs-sm-13 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19 my-1 ">
            An example of a first price ticket is 5635
          </p>
          <p className=" f2  fs-xs-14 fs-sm-13 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19 my-1 ">
            X=5, A=6, B=3, C=5, AB=63, BC=35, AC=65,
          </p>
          <p className=" f2  fs-xs-14 fs-sm-13 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19 my-1 ">
            ABC = 635, XABC = 5635
          </p>

          <label style={{ marginTop: 25 }} className="f3 fs-xs-17 fs-sm-11 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19 primary">
            Dear [Upto 3 digits game]:
          </label>
          <p className=" f2  fs-xs-14 fs-sm-13 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19 my-1 Blue_color">
            01:00 PM, 06:00 PM & 08:00 PM
          </p>
          <p className=" f2  fs-xs-14 fs-sm-13 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19 my-1 ">
            An example of a first price ticket is 062
          </p>
          <p className=" f2  fs-xs-14 fs-sm-13 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19 my-1 ">
            A=0, B=6, C=2, AB=06, BC=62, AC=02,
          </p>
          <p className=" f2  fs-xs-14 fs-sm-13 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19 my-1 ">
            ABC = 062
          </p>
          {/* --------------------------------------------------single-------------------------------------------------------------- */}
          <label style={{ marginTop: 25 }} className="f3 fs-xs-17 fs-sm-11 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19 primary">
            Single Digit Game - A, B, C Board
          </label>
          <p className=" f2  fs-xs-14 fs-sm-13 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19 ">
            Single digit games can be played on any board between A, B and C.
          </p>
          <div className="col-md-5">
            <div className=" my-2 sale_value ">
              <div className="w-100 d-flex ac-jc  table_title4 ">
                <h4 className="f3 fs-xs-15 fs-sm-11 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19 text-center  white ">
                  Ticket Price: {gameData[0]?.variations[0]?.ticket_price || 11}
                </h4>
              </div>

              <table className="table3 text-center" style={{ tableLayout: 'fixed', width: '100%' }}>
                <tbody>
                  {/* Header Row (Names) */}
                  <tr className="tr_table">
                    {gameData[0]?.variations[0]?.combinations?.map((item, index) => (
                      <td key={`name-${index}`} className="td_table">
                        <p className="form-control7 f3 fs-xs-17 fs-sm-11 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19 text-center">
                          {item?.name}
                        </p>
                      </td>
                    ))}
                  </tr>

                  {/* Price Row */}
                  <tr className="tr_table">
                    {gameData[0]?.variations[0]?.combinations?.map((item, index) => (
                      <td key={`price-${index}`} className="td_table">
                        <input
                          type="text"
                          value={item?.price}
                          defaultValue="100"
                          className="form-control7 f3 fs-xs-15 fs-sm-11 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19 text-center placholdercolorchanges2"
                          onChange={(e) =>
                            handleChange(
                              gameData[0].variations[0].fee_price_id,
                              item.column,
                              e.target.value
                            )
                          }
                        />
                      </td>
                    ))}
                  </tr>
                </tbody>
              </table>

            </div>
          </div>

          <div className="col-md-5 my-2">
            <button onClick={() => confirmUpdate(handleUpdateSingle, gameData[0]?.variations[0])} className="add-button f3 fs-xs-15 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 white">
              {loading1 === gameData[0]?.variations[0]?.type ? <>
                <span
                  className="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                  style={{ color: "white" }}
                ></span>
              </> : "Update"}
            </button>
          </div>

          {/* --------------------------------------------------Double-------------------------------------------------------------- */}

          <label className="f3 fs-xs-17 fs-sm-11 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19 mt-4 primary">
            Double Digit Game - AB, BC, AC
          </label>
          <p className=" f2  fs-xs-14 fs-sm-13 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19">
            In a double digit game, players can pick double numbers in the last three
            digits of the result in the combination of AB, BC and AC.
          </p>
          <div className="col-md-5">
            <div className=" my-2 sale_value ">
              <div className="w-100 d-flex ac-jc  table_title4 ">
                <h4 className="f3 fs-xs-15 fs-sm-11 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19 text-center  white ">
                  Ticket Price: {gameData[1]?.variations[0]?.ticket_price || 11}
                </h4>
              </div>

              <table className="table3 text-center" style={{ tableLayout: 'fixed', width: '100%', borderTop: 'none !important' }}>
                <tbody>
                  {/* Header Row (Names) */}
                  <tr className="tr_table">
                    {gameData[1]?.variations[0]?.combinations?.map((item, index) => (

                      <td key={`name-${index}`} className="td_table">
                        <p className="form-control7 f3 fs-xs-17 fs-sm-11 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19 text-center">
                          {item?.name}
                        </p>
                        {console.log("item++", item)}
                      </td>
                    ))}
                  </tr>

                  {/* Price Row */}
                  <tr className="tr_table">
                    {gameData[1]?.variations[0]?.combinations?.map((item, index) => (
                      <td key={`price-${index}`} className="td_table">
                        <input
                          type="text"
                          value={item?.price}
                          defaultValue="100"
                          className="form-control7 placholdercolorchanges2 f3 fs-xs-15 fs-sm-11 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19 text-center"
                          onChange={(e) =>
                            handleChange(
                              gameData[1].variations[0].fee_price_id,
                              item.column,
                              e.target.value
                            )
                          }
                        />
                      </td>
                    ))}
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div className="col-md-5 my-2">
            <button onClick={() => confirmUpdate(handleUpdateSingle, gameData[1]?.variations[0])} className="add-button f3 fs-xs-15 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 white">
              {loading1 === gameData[1]?.variations[0]?.type ? <>
                <span
                  className="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                  style={{ color: "white" }}
                ></span>
              </> : "Update"}
            </button>
          </div>
          {/* --------------------------------------------------triple-------------------------------------------------------------- */}

          <label className="f3 fs-xs-17 fs-sm-11 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19 mt-4 primary">
            Three Digit Game - ABC
          </label>
          <p className=" f2  fs-xs-14 fs-sm-13 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19 ">
            If a player places a bet on an ABC 3 digit game in a particular
            lottery there is a three chance of winning.
          </p>


          <div className="row" style={{ display: 'flex', flexDirection: 'column' }}>
            {threegame ? (
              <>
                {threegame.variations?.map((ticket, index) =>
                  index !== 1 ? (
                    <div key={ticket.fee_price_id || index} className="col-md-5">
                      <div className="my-2 sale_value">
                        {/* Title */}
                        <div className="w-100 d-flex ac-jc table_title4">
                          <h4 className="f3 text-center white f3 fs-xs-15 fs-sm-11 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19">
                            Ticket Price: {ticket.ticket_price}
                          </h4>
                        </div>

                        {/* Combinations Table */}
                        <table className="table3 text-center" style={{ tableLayout: 'fixed', width: '100%' }}>
                          <tbody>
                            <tr className="tr_table">
                              {ticket.combinations.map((header, i) => (
                                <td key={i} className="td_table">
                                  <p className="form-control7 f3 fs-xs-17 fs-sm-11 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19 text-center">
                                    {header.name}
                                  </p>
                                </td>
                              ))}
                            </tr>
                            <tr className="tr_table">
                              {ticket.combinations.map((val, i) => (
                                <td key={i} className="td_table">
                                  <input
                                    type="number"
                                    value={val.price}
                                    onChange={(e) =>
                                      handleChange(
                                        ticket.fee_price_id,
                                        val.column,
                                        e.target.value
                                      )
                                    }
                                    className="placholdercolorchanges2 form-control7 f3 text-center fs-xs-17 fs-sm-11 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19 placholdercolorchanges2"
                                  />
                                </td>
                              ))}
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  ) : null
                )}

                {/* Single Update Button */}
                <div className="col-md-5 my-2">
                  <button
                    onClick={() => confirmUpdate(handleUpdate, threegame?.variations[0])}
                    disabled={loading2}
                    className="add-button f3 fs-xs-15 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 white"
                  >
                    {loading2 === threegame?.variations[0]?.type ? <>
                      <span
                        className="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"
                        style={{ color: "white" }}
                      ></span>
                    </> : "Update"}
                  </button>
                </div>
              </>
            ) : (
              <p className="text-center mt-4">Loading Three Digit Game...</p>
            )}
          </div>

          {/* --------------------------------------------------triple ABC-------------------------------------------------------------- */}

          <label className="f3 fs-xs-17 fs-sm-11 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19 mt-4 primary">
            Three Digit Game - ABC
          </label>
          <p className=" f2  fs-xs-14 fs-sm-13 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19">
            If a player places a bet on an ABC 3 digit game in a particular lottery there is a two chance of winning.
          </p>

          {gameData[2]?.variations?.map((ticket, index) =>
            index === 1 ? (
              <div key={ticket.fee_price_id || index} className="col-md-5">
                <div className="my-2 sale_value">
                  {/* Ticket Title */}
                  <div className="w-100 d-flex ac-jc table_title4">
                    <h4 className="f3 text-center white f3 fs-xs-15 fs-sm-11 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19">
                      Ticket Price: {ticket.ticket_price}
                    </h4>
                  </div>

                  {/* Combinations Table */}
                  <table className="table3 text-center" style={{ tableLayout: 'fixed', width: '100%' }}>
                    <tbody>
                      {/* Header Row */}
                      <tr className="tr_table">
                        {ticket.combinations.map((header, i) => (
                          <td key={i} className="td_table">
                            <p className="form-control7 f3 fs-xs-17 fs-sm-11 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19 text-center">{header.name}</p>
                          </td>
                        ))}
                      </tr>

                      {/* Input Row */}
                      <tr className="tr_table">
                        {ticket.combinations.map((val, i) => (
                          <td key={i} className="td_table">
                            <input
                              type="number"
                              value={val.price}
                              onChange={(e) =>
                                handleChange(ticket.fee_price_id, val.column, e.target.value)
                              }
                              className="placholdercolorchanges2 form-control7 f3 text-center fs-xs-17 fs-sm-11 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19"
                            />
                          </td>
                        ))}
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            ) : null
          )}

          <div className="col-md-5 my-2">
            <button
              onClick={() => confirmUpdate(handleUpdateSingle, gameData[2]?.variations?.[5])}
              className="add-button f3 fs-xs-15 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 white"
            >
              {loading1 === gameData[2]?.variations?.[5]?.type ? <>
                <span
                  className="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                  style={{ color: "white" }}
                ></span>
              </> : "Update"}
            </button>
          </div>


          {/* --------------------------------------------------Four ABC-------------------------------------------------------------- */}
          <label className="f3 fs-xs-17 fs-sm-11 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19 mt-4 primary">
            Four Digit Game - XABC
          </label>
          <p className=" f2  fs-xs-14 fs-sm-13 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19 my-1 primary">
            This one available only in Kerala Lottery.
          </p>
          <p className=" f2  fs-xs-14 fs-sm-13 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19 my-1">
            If a player places a bet on an XABC 4 digit game in a particular
            lottery there is a 4 chance of winning.
          </p>
          <p className=" f2  fs-xs-14 fs-sm-13 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19 my-1">
            (XABC Matching or ABC Matching or BC Matching or C Matching)
          </p>

          <div className="row" style={{ display: 'flex', flexDirection: 'column' }}>
            {fourgame ? (
              <>
                {/* <label className="f3 fs-xs-17 fs-sm-11 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19 mt-4 primary">
                {fourgame.game_type}
              </label>
              <p className="f2 fs-xs-14 fs-sm-13 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19 my-1">
                {fourgame.description}
              </p> */}

                {fourgame.variations?.map((ticket, index) =>
                  index !== 0 ? (
                    <div key={ticket.fee_price_id || index} className="col-md-5">
                      <div className="my-2 sale_value ">
                        {/* Title */}
                        <div className="w-100 d-flex ac-jc table_title4">
                          <h4 className="f3 text-center white f3 fs-xs-15 fs-sm-11 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19">
                            Ticket Price: {ticket.ticket_price}
                          </h4>
                        </div>

                        {/* Combinations Table */}
                        <table className="table3 text-center" style={{ tableLayout: 'fixed', width: '100%' }}>
                          <tbody>
                            <tr className="tr_table">
                              {ticket.combinations.map((header, i) => (
                                <td key={i} className="td_table">
                                  <p className="form-control7 f3 fs-xs-17 fs-sm-11 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19 text-center">
                                    {header.name}
                                  </p>
                                </td>
                              ))}
                            </tr>
                            <tr className="tr_table">
                              {ticket.combinations.map((val, i) => (
                                <td key={i} className="td_table">
                                  <input
                                    type="number"
                                    value={val.price}
                                    onChange={(e) =>
                                      handleChange(
                                        ticket.fee_price_id,
                                        val.column,
                                        e.target.value
                                      )
                                    }
                                    className="placholdercolorchanges2 form-control7 f3 text-center fs-xs-17 fs-sm-11 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19"
                                  />
                                </td>
                              ))}
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  ) : null
                )}

                {/* Single Update Button */}
                <div className="col-md-5 my-2">
                  <button
                    onClick={() => confirmUpdate(handleUpdate, fourgame?.variations[0])}
                    disabled={loading2}
                    className="add-button f3 fs-xs-15 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 white"
                  >
                    {loading2 === fourgame?.variations[0]?.type ? <>
                      <span
                        className="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"
                        style={{ color: "white" }}
                      ></span>
                    </> : "Update"}
                  </button>
                </div>
              </>
            ) : (
              <p className="text-center mt-4">Loading Three Digit Game...</p>
            )}
          </div>

          {/* --------------------------------------------------fourXABC-------------------------------------------------------------- */}
          <label className="f3 fs-xs-17 fs-sm-11 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19 mt-4 primary">
            Four Digit Game - XABC
          </label>
          <p className=" f2  fs-xs-14 fs-sm-13 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19 my-1 primary">
            This is available in Dear and Kerala Lottery.
          </p>
          <p className=" f2  fs-xs-14 fs-sm-13 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19 .my-1">
            If a player places a bet on an XABC 4 digit game in a particular
            lottery there is a one chance of winning only in four digit winning
          </p>

          {gameData[3]?.variations?.map((ticket, index) =>
            index === 0 ? (
              <div key={ticket.fee_price_id || index} className="col-md-5">
                <div className="my-2 sale_value">
                  {/* Ticket Title */}
                  <div className="w-100 d-flex ac-jc table_title4">
                    <h4 className="f3 text-center white f3 fs-xs-15 fs-sm-11 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19">
                      Ticket Price: {ticket.ticket_price}
                    </h4>
                  </div>

                  {/* Combinations Table */}
                  <table className="table3 text-center" style={{ tableLayout: 'fixed', width: '100%' }}>
                    <tbody>
                      {/* Header Row */}
                      <tr className="tr_table">
                        {ticket.combinations.map((header, i) => (
                          <td key={i} className="td_table">
                            <p className="form-control7 f3 fs-xs-17 fs-sm-11 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19 text-center">{header.name}</p>
                          </td>
                        ))}
                      </tr>

                      {/* Input Row */}
                      <tr className="tr_table">
                        {ticket.combinations.map((val, i) => (
                          <td key={i} className="td_table">
                            <input
                              type="number"
                              value={val.price}
                              onChange={(e) =>
                                handleChange(ticket.fee_price_id, val.column, e.target.value)
                              }
                              className="placholdercolorchanges2 form-control7 f3 text-center fs-xs-17 fs-sm-11 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19"
                            />
                          </td>
                        ))}
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            ) : null
          )}

          <div className="col-md-5 my-2">
            <button
              onClick={() => confirmUpdate(handleUpdateSingle, gameData[3]?.variations?.[2])}
              className="add-button f3 fs-xs-15 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 white"
            >
              {loading1 === gameData[3]?.variations?.[2]?.type ? <>
                <span
                  className="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                  style={{ color: "white" }}
                ></span>
              </> : "Update"}
            </button>
          </div>

          {loading && <Loader />}
          {popup && (
            <div className="img-popup-design">
              <div className="img-popup">
                <p className="f3 fs-xs-14 fs-sm-15 fs-md-15 fs-lg-15 fs-xl-17 fs-xxl-19 primary">
                  Are you sure you want to Update?
                </p>
                <div style={{ paddingTop: 20 }} className="d-flex ac-jb px-2  f3 fs-xs-14 fs-sm-15 fs-sm-11 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19">
                  <button onClick={() => setPopup(false)} className="no-btn w-40">
                    No
                  </button>
                  <button
                    onClick={executePendingUpdate}
                    className="yes-btn f2 w-40 f3 fs-xs-14 fs-sm-15 fs-sm-11 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19"
                  >
                    {popupLoading ? (
                      <>
                        <span
                          className="spinner-border spinner-border-sm"
                          role="status"
                          aria-hidden="true"
                          style={{ color: "white", padding: 8 }}
                        ></span>
                      </>
                    ) : (
                      <span style={{ top: -1.5, position: 'relative' }}>Yes</span>
                    )}
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      </CustomScroll>
    </div >
  );
};

export default WinnerAgency;
